import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web'; // For animations
import { useInView } from 'react-intersection-observer'; // For triggering animations on scroll
import { handleSignupRedirect } from '../../../utils/locationUtils';
import './CreatorHero.css';
import whatsApp from '../../../assets/svg/edc-whatsapp.svg'; // Updated path
import video1 from '../../../assets/videos/CreatorHeroVideos/Hero_Creator_01.mp4';
import video2 from '../../../assets/videos/CreatorHeroVideos/Hero_Creator_02.mp4';
import video3 from '../../../assets/videos/CreatorHeroVideos/Hero_Creator_03.mp4';
import { WHATSAPP_COMMUNITY_URL } from '../../../constants/constants';

const CreatorHero = ({ onButtonClick }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  // Array of videos to randomly select from
  const videos = [video1, video2, video3];

  // Select random video on component mount
  const [selectedVideo] = useState(() => {
    const randomIndex = Math.floor(Math.random() * videos.length);
    return videos[randomIndex];
  });

  // Intersection Observer Hooks for animations
  const [headingRef, headingInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [descriptionRef, descriptionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [buttonRef, buttonInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [videoRef, videoInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Animations for elements
  const headingAnimation = useSpring({
    opacity: headingInView ? 1 : 0,
    transform: headingInView ? 'translateY(0px)' : 'translateY(-50px)',
  });

  const descriptionAnimation = useSpring({
    opacity: descriptionInView ? 1 : 0,
    transform: descriptionInView ? 'translateY(0px)' : 'translateY(50px)',
  });

  const buttonAnimation = useSpring({
    opacity: buttonInView ? 1 : 0,
    transform: buttonInView ? 'translateY(0px)' : 'translateY(50px)',
  });

  // Animation for video load-in
  const videoAnimation = useSpring({
    opacity: videoInView && isVideoLoaded ? 1 : 0,
    transform: videoInView && isVideoLoaded ? 'scale(1)' : 'scale(0.8)',
  });

  // Handle video load event
  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  const handleLoginClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      handleSignupRedirect();
    }
  };

  const handleJoinCommunityClick = () => {
    window.open(WHATSAPP_COMMUNITY_URL, '_blank');
  };

  return (
    <div className="creator-hero">
      {/* Animated Heading */}
      <animated.div
        ref={headingRef}
        style={headingAnimation}
        className="creator-hero-heading"
      >
        <h1>
          UNLOCK YOUR <br />
          EVERYDAY CREATIVITY
        </h1>
      </animated.div>

      {/* Animated Description */}
      <animated.p
        ref={descriptionRef}
        style={descriptionAnimation}
        className="creator-hero-description"
      >
        EDC squared provides a new way to monetize your content by giving you
        access to the brands you love.
      </animated.p>

      {/* Animated Button */}
      <animated.div
        ref={buttonRef}
        style={buttonAnimation}
        className="creator-login-button-container"
      >
        <button
          onClick={handleLoginClick}
          className="creator-login-button-home"
        >
          GET ACCESS
        </button>
      </animated.div>

      {/* Animated Video (replacing the image) */}
      <animated.div
        ref={videoRef}
        style={videoAnimation}
        className="creator-hero-video-wrapper"
      >
        <video
          className="creator-hero-video"
          onLoadedData={handleVideoLoad}
          autoPlay
          loop
          muted
          playsInline
          loading="lazy" // Enable browser-native lazy loading
        >
          <source src={selectedVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </animated.div>

      {/* Animated WhatsApp Section */}
      <animated.div className="creator-hero-community">
        <p>
          Find out about the latest opportunities, tips/tricks on content
          creation and access to our bootcamps via our{' '}
          <span className="community-highlight">WhatsApp channel</span>
        </p>
        <div className="community-button-container">
          <button
            onClick={handleJoinCommunityClick}
            className="community-button"
          >
            <img
              src={whatsApp}
              alt="WhatsApp Icon"
              className="community-button-image"
            />
            JOIN COMMUNITY
          </button>
        </div>
      </animated.div>
    </div>
  );
};

export default CreatorHero;
